import request from '../../utils/requests'
/** * Tag: OrgFormConfig */
const baseUrl ="/api/OrgFormConfig";

/** * 匿名：获取机构表单配置(不分页) * @param {*} body * { *    DicGroup Desc:标签分组
老师：FineCoach
学员：FineStudent
客户表单：CustomerForm
学员表单：StudentForm
培训类型：TrainType
课程类别: CourseType
现金支付场景: CashPayPayScene Required:false *    OrgId Desc:机构id（后台使用，匿名方法时传） Required:false *    IsDisable Desc:是否禁用（后台使用） Required:false *    BranchId Desc:校区id Required:false * } */async function _getListForAnonymous(body) {  return request(baseUrl+'/getListForAnonymous',{    method: 'POST',    body: body,  });
}

/** * 获取机构表单配置(不分页) * @param {*} body * { *    DicGroup Desc:标签分组
老师：FineCoach
学员：FineStudent
客户表单：CustomerForm
学员表单：StudentForm
培训类型：TrainType
课程类别: CourseType
现金支付场景: CashPayPayScene Required:false *    OrgId Desc:机构id（后台使用，匿名方法时传） Required:false *    IsDisable Desc:是否禁用（后台使用） Required:false *    BranchId Desc:校区id Required:false * } */async function _getList(body) {  return request(baseUrl+'/getList',{    method: 'POST',    body: body,  });
}

/** * 表单设置是否启用 * @param {*} body * { *    OrgDictionaryId Desc:主键 Required:true *    DicGroup Desc:标签分组 
客户表单：CustomerForm; Required:true *    IsOpen Desc:是否开启(0：否，1：是) Required:false *    IsRequire Desc:是否必填(0：否，1：是) Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _setIsOpen(body) {  return request(baseUrl+'/setIsOpen',{    method: 'POST',    body: body,  });
}

/** * 表单设置是否必填 * @param {*} body * { *    OrgDictionaryId Desc:主键 Required:true *    DicGroup Desc:标签分组 
客户表单：CustomerForm; Required:true *    IsOpen Desc:是否开启(0：否，1：是) Required:false *    IsRequire Desc:是否必填(0：否，1：是) Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _setIsRequire(body) {  return request(baseUrl+'/setIsRequire',{    method: 'POST',    body: body,  });
}

export default{  _getListForAnonymous,  _getList,  _setIsOpen,  _setIsRequire}



// WEBPACK FOOTER //
// ./src/services/orgFormConfig.js